export default "__VITE_ASSET__BaV8wSUk__"